<template>
    <div>
        <el-dialog id="dialog"
                   class="popup search"
                   :width="windowWidth >= 1200 ? '1170px' : '100%'"
                   :top="windowWidth >= 1200 ? '80px' : '0'"
                   :append-to-body="true"
                   :destroy-on-close="true"
                   :show-close="false"
                   :visible.sync="dialogVisible"
                   @opened="openPopup"
                   @close="closePopup"
                   @closed="$router.push(laravel.url.replace(laravel.prefix, ''))">
            <button class="btn popup__close" @click.prevent="dialogVisible = false">
                <i class="el-icon-close"></i>
            </button>
            <div class="search__wrapper" :class="show && windowWidth < 992 && items ? 'search__wrapper--full' : ''">
                <div class="search__header">
                    <span class="title title--s search__title">{{ $lang('search.title') }}</span>
                    <div class="search__form">
                        <label class="search__inner">
                            <svg class="search__icon" width="14" height="14" v-if="windowWidth >= 992">
                                <use xlink:href="/assets/front/img/sprite.svg#icon-search"></use>
                            </svg>
                            <el-input class="input input--big search__input" :placeholder="$lang('search.placeholder')" v-model="name" clearable></el-input>
                        </label>
                        <button class="btn btn--middle btn--main-bg search__button" @click="buttonSearchPage()" v-if="windowWidth >= 992">{{ $lang('search.button') }}</button>
                        <button class="btn btn--main-bg search__button" @click="buttonSearchPage()" v-else>
                            <svg width="14" height="14">
                                <use xlink:href="/assets/front/img/sprite.svg#icon-search"></use>
                            </svg>
                        </button>
                    </div>
                </div>
                <template v-if="items">
                    <simplebar class="search__items" data-simplebar-auto-hide="false" v-if="windowWidth >= 992">
                        <img v-if="show" src="/assets/front/img/spinner.gif" class="search__loading">
                        <a :href="page.link" class="search__item" target="_blank" v-else v-for="page in listPages">
                            <svg class="search__item-icon" width="17" height="17">
                                <use xlink:href="/assets/front/img/sprite.svg#icon-export"></use>
                            </svg>
                            <div class="search__avatarbox">
                                <img :src="page.main_image.url" :alt="page.name" class="search__avatar" v-if="page.main_image">
                                <img src="/assets/front/img/memory/avatar.svg" :alt="page.name" class="search__avatar" v-else>
                            </div>
                            <div class="search__info">
                                <span class="search__name">{{ page.full_name }}</span>
                                <span class="search__years">{{ page.start.year }} — {{ page.end.year }}</span>
                            </div>
                        </a>
                        <span v-if="!show && listPages.length === 0">{{ $lang('search.pagesNotFound') }}</span>
                    </simplebar>
                    <div class="search__items" v-else>
                        <img v-if="show" src="/assets/front/img/spinner.gif" class="search__loading">
                        <a :href="page.link" class="search__item" target="_blank" v-else v-for="page in listPages">
                            <svg class="search__item-icon" width="17" height="17">
                                <use xlink:href="/assets/front/img/sprite.svg#icon-export"></use>
                            </svg>
                            <div class="search__avatarbox">
                                <img :src="page.main_image.url" :alt="page.name" class="search__avatar" v-if="page.main_image">
                                <img src="/assets/front/img/memory/avatar.svg" :alt="page.name" class="search__avatar" v-else>
                            </div>
                            <div class="search__info">
                                <span class="search__name">{{ page.full_name }}</span>
                                <span class="search__years">{{ page.start.year }} — {{ page.end.year }}</span>
                            </div>
                        </a>
                        <span v-if="!show && listPages.length === 0" style="display: block; padding-bottom: 2.5rem;">{{ $lang('search.pagesNotFound') }}</span>
                    </div>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import simplebar from "simplebar-vue";
import 'simplebar/dist/simplebar.min.css';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
    name: 'Search',
    components: {
        simplebar
    },
    data: () => ({
        dialogVisible: false,
        laravel: window.laravel,
        listPages: [],
        scroll: 0,
        name: '',
        items: false,
        show: false,
        timerId: 0,
    }),
    computed: {
        ...mapState('home', [
            'pages'
        ])
    },
    watch: {
        name() {
            clearTimeout(this.timerId);

            this.timerId = setTimeout(() => {
                this.buttonSearchPage();
            }, 1000);
        },
        pages(val) {
            this.listPages = val;
        }
    },
    methods: {
        ...mapActions('home', [
            "searchPage"
        ]),
        ...mapMutations('home', [
            "setPages"
        ]),
        buttonSearchPage() {
            if (this.name.length < 3) {
                this.items = false;
                return;
            }

            this.listPages = [];

            this.items = true;
            this.show = true;
            this.searchPage(this.name).finally(() => {
                this.show = false;
            })
        },
        closeDialogs() {
            this.dialogVisible = false;
        },
        closePopup() {
            if (this.scroll > 0) {
                document.body.style.overflow = 'auto';
                window.scrollTo(0,this.scroll);
                document.body.style.removeProperty( 'overflow');
                this.scroll = 0;
            }

            this.setPages([]);
        },
        openPopup() {
            if (window.innerWidth < 992) {
                document.body.style.overflow = 'auto';
                this.scroll = window.scrollY;
                window.scrollTo(0,0);
                document.body.style.removeProperty( 'overflow');
            }
        }
    },
    mounted() {
        this.dialogVisible = true;
    },
    beforeDestroy() {
        if (this.scroll > 0) {
            document.body.style.overflow = 'auto';
            window.scrollTo(0,this.scroll);
            document.body.style.removeProperty( 'overflow');
            this.scroll = 0;
        }
    }
}
</script>

